<script>
	import Nav from "./Nav.svelte";
	import Footer from "./Footer.svelte";
	import Login from "./Login.svelte";
	import Register from "./Register.svelte";


	//If loginOrRegister == false renders <Login/> if True renders <Register/> 
	let loginOrRegister = false;

	// $:{
	// 	console.log('loginOrRegister:', loginOrRegister);
	// }


</script>


<Nav changeNavElement={true}/>
<main>
	<div class="signUpContainer">

		{#if loginOrRegister}
			<Register bind:changeToLogin={loginOrRegister} />
		{:else}
			<Login bind:changeToRegister={loginOrRegister}/>
		{/if}

		

		<div class="imgSlide">
			
		</div>

		
	</div>
	<Footer/>	
</main>



<style >


/*Sign up section for mobile*/
@media only screen and (max-width: 600px){
	main {
			width:100%;
			height:100%;
			background-color: white;
			display: block;
			overflow: scroll;
			overflow-x: hidden;
			scrollbar-width: none;
			position: relative;
			

	}

	main::-webkit-scrollbar {
	    width: 0em;
	}

	.signUpContainer{
		width: 100vw;
		height: 100vh;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
	}


	.imgSlide{
		width: 50%;
		height: 100%;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center center;
		animation-duration: 30s;
		animation-name: orangeSlide;
		animation-iteration-count: infinite;
		animation-timing-function: ease-in;
		will-change: transform;
	}

	@keyframes orangeSlide {
		0%{
			background-image: url('/img/mediterranean_img/seaAndEarth.jpg');
			background-position: center right;
		}
		20% {
			background-image: url('/img/mediterranean_img/sausageTable.jpg');
			background-position: left center;
			
		}
		40%{
			background-image: url('/img/mediterranean_img/cheese.jpg');
			background-position: center right;
			
		}
		80%{
			background-image: url('/img/mediterranean_img/milk2.jpg');
			background-position: center right;
			
		}
		100% {
		
			background-image: url('/img/mediterranean_img/cheeseRow.jpg');
			background-position: left center;

		}
	}
}

/*Sign up section for desktop*/
@media only screen and (min-width: 768px){
	
	main {
			width:100%;
			height:100%;
			background-color: white;
			display: block;
			overflow: scroll;
			overflow-x: hidden;
			scrollbar-width: none;
			position: relative;
			

	}

	main::-webkit-scrollbar {
	    width: 0em;
	}

	.signUpContainer{
		width: 100vw;
		height: 100vh;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
	}


	.imgSlide{
		width: 50%;
		height: 100%;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center center;
		animation-duration: 30s;
		animation-name: orangeSlide;
		animation-iteration-count: infinite;
		animation-timing-function: ease-in;
		will-change: transform;
	}

	@keyframes orangeSlide {
		0%{
			background-image: url('/img/mediterranean_img/seaAndEarth.jpg');
			background-position: center right;
		}
		20% {
			background-image: url('/img/mediterranean_img/sausageTable.jpg');
			background-position: left center;
			
		}
		40%{
			background-image: url('/img/mediterranean_img/cheese.jpg');
			background-position: center right;
			
		}
		80%{
			background-image: url('/img/mediterranean_img/milk2.jpg');
			background-position: center right;
			
		}
		100% {
		
			background-image: url('/img/mediterranean_img/cheeseRow.jpg');
			background-position: left center;

		}
	}

}



</style>